import React from "react";
import Header from "../../../common/components/Header";
import {Grid} from "semantic-ui-react";
import Breadcrumb from "../../../common/partials/Breadcrumb/Breadcrumb";
import {InlineLoading} from "../../../common/partials/Loading";
import PricingTablesTableV2 from "./PricingTablesTableV2";
import {setBreadCrumb} from "../../../veritas/breadcrumb/BreadcrumbActions";
import {connect} from "react-redux";
import {fetchPricingTablesTableDataV2, unmountPricingDetailPageV2} from "../actions/PricingTablesActions";
import Sidebar from "../../../common/components/Sidebar";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";


export class PricingTablesListPageV2 extends React.Component {

    componentDidMount() {
        this.props.getPricingTablesData();
        document.title = `Billing - Pricing Tables`;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/v2/pricing-tables', text: 'Pricing Tables' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        });
    }

    componentWillUnmount() {
        this.props.unmountPricingDetail();
    }

    render() {
        const { filteredPricingTablesV2, pricingTables } = this.props;
        return (
            <div className="billing">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {pricingTables.length !== 0
                            ? (<PricingTablesTableV2 PricingTablesData={filteredPricingTablesV2} />)
                            : (<InlineLoading />) }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    pricingTables: state.billing.pricing.pricingTablesV2,
    filteredPricingTablesV2: state.billing.pricing.filteredPricingTablesV2,
});

const mapDispatchToProps = dispatch => ({
    getPricingTablesData: () => {dispatch(fetchPricingTablesTableDataV2())},
    unmountPricingDetail: () => { dispatch(unmountPricingDetailPageV2()) },
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PricingTablesListPageV2)
